<template>
  <div id="create-table-modal" class="editor-modal">
    <h3>{{ $t("tables.title") }}</h3>
    <div class="close-btn" @click="$emit('close')">
      <i class="fa-light fa-times"></i>
    </div>
    <form @submit.stop.prevent="AddTable">
      <div class="input-wrapper">
        <custom-input
          :label="$t('tables.columns')"
          :placeholder="$t('tables.columns')"
          type="number"
          name="columns"
          v-model="columns"
          focusInputField
          :invalidInput="!validColumnNumber"
        />
        <custom-input
          :label="$t('tables.rows')"
          :placeholder="$t('tables.rows')"
          type="number"
          name="columns"
          v-model="rows"
          :invalidInput="!validRowNumber"
        />
      </div>
      <span v-if="!isValid" class="text-xs text-danger">{{ $t("tables.error-message") }}</span>
      <checkbox class="checkbox" :lightLabel="true" :label="$t('tables.header-checkbox-row')" v-model="applyTableHeadRow" />
      <checkbox class="checkbox" :lightLabel="true" :label="$t('tables.header-checkbox-column')" v-model="applyTableHeadColumn" />
      <div class="actions">
        <button type="submit" class="btn btn-primary btn-xs" :disabled="!isValid">{{ $t("done") }}</button>
        <button type="button" class="btn btn-secondary btn-xs" @click="$emit('close')">{{ $t("cancel") }}</button>
      </div>
    </form>
  </div>
</template>

<script>
import Checkbox from "@/components/Checkbox";
export default {
  components: {
    Checkbox
  },
  props: {
    onCreate: Function
  },

  data() {
    return {
      columns: 1,
      rows: 1,
      applyTableHeadRow: false,
      applyTableHeadColumn: false,
    };
  },
  computed: {
    validColumnNumber() {
      return this.columns && this.columns > 0 && this.columns <= 10;
    },
    validRowNumber() {
      return this.rows && this.rows > 0 && this.rows <= 10;
    },
    isValid() {
      return this.validColumnNumber && this.validRowNumber;
    }
  },
  methods: {
    AddTable() {
      this.onCreate(this.columns, this.rows, this.applyTableHeadRow, this.applyTableHeadColumn);
      this.$emit("close");
    }
  }
};
</script>

<style lang="less">
#create-table-modal {
  padding: 30px 25px 25px 25px;
  display: flex;
  flex-direction: column;
  h3 {
    margin-bottom: 0;
  }
  .close-btn {
    cursor: pointer;
    position: absolute;
    right: 8px;
    top: 8px;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    color: var(--charcoal-50);
    &:hover {
      color: var(--charcoal);
    }
  }
  .input-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 8px;
    position: relative;
    input {
      width: 100%;
    }
  }
  .form-group {
    display: flex;
    flex-direction: column;

    label {
      margin-bottom: 0;
    }
  }
  .actions {
    display: flex;
    gap: 12px;
  }
}
</style>
